export default __webpack_public_path__ + "static/industry-technology-0c0d1770ecf1be0d74bfa2494449af26.webp";